export const menuItemsDataSa = [
  {
	title: 'Main',
	url: '/',
  }, 
  
  {
    title: 'Merchants',
    url: '/merchant',
    submenu: [
      {
        title: 'Create Merchant',
        url: '/merchant/create',
		role: 'sa'
      },
    ],
  },
    	

  
  {
    title: 'Users',
    url: '/user',
    submenu: [
      {
        title: 'Create User',
        url: '/user/create',
      },
    ],
  },
    
  
  {
    title: 'Devices',
    url: '/device',
    submenu: [
      {
        title: 'Create Device',
        url: '/device/create',
      },
    ],
  },
  
  {
    title: 'Pass',
    url: '/normalticket',
  },  

  {
    title: 'City Pass',
    url: '/citypassticket',
  },
/*
 {
    title: 'Coupon Events',
    url: '/couponevent',
    submenu: [
      {
        title: 'Create Coupon Events',
        url: '/couponevent/create',
      },
    ],
  },
  */
  /*
  {
    title: 'Coupon Users',
    url: '/couponuser',
    submenu: [
      {
        title: 'Create Coupon User',
        url: '/couponuser/create',
      },
    ],
  },
  */    
  
  {
    title: 'Reports',
    url: '/monthlyreport',

	 submenu: [
      {
        title: 'Monthly Report',
        url: '/monthlyreport',
      },

      {
        title: 'Daily Report',
        url: '/dailyreport',
      },
	  /*
      {
        title: 'Monthly User',
        url: '/monthlyreport',
      },
	  */
    ],

  }, 
  
  {
    title: 'Payment',
    url: '/payment',
	
	submenu: [
      {
        title: 'Merchants Account Balance',
        url: '/payment/payment_merchant_list',
      },

      {
        title: 'Payment Reminder Setting',
        url: '/payment/payment_email_template',
      },
	  /*
      {
        title: 'Monthly User',
        url: '/monthlyreport',
      },
	  */
    ],	
	/*
	submenu: [
      {
        title: 'History',
        url: '/payment/history',
      },
    ],
	*/
  }, 
];